<template>
	<div class="expect-job-info">
		<p class="job-apply-text">求职意向</p>
		<div>
			<title-intention ref='zpcateId'></title-intention>
			<salary-intention ref='salary'></salary-intention>
			<area-intention ref='targetAreaId'></area-intention>
		</div>
	</div>
</template>
<script>
import titleIntention from './titleIntention';
import salaryIntention from './salaryIntention';
import areaIntention from './areaIntention';
export default {
	components: {
		titleIntention,
		salaryIntention,
		areaIntention
	},
	data() {
		return {};
	},
	methods: {
		checkNull(prop) {
			this.$refs[prop].checkNull();
		}
	}
};
</script>
<style lang="scss" scoped>
@import '../../../assets/style/public.scss';
.expect-job-info {
	height: px2rem(490px);
	background: #fff;
	color: #999;
	font-size: px2rem(38px);
	overflow: hidden;
	margin-bottom: px2rem(20px);
	.job-apply-text {
		padding: px2rem(30px) 0 px2rem(6px) px2rem(30px);
		color: #999;
		font-size: px2rem(28px);
	}
}
.expect-job-detail {
	padding: px2rem(50px);
	margin: 0 px2rem(30px);
	line-height: px2rem(38px);
}
</style>



// WEBPACK FOOTER //
// index.vue?0672bab1